
define('text!templates/modules/calendar/calendar/calendar-component/item/calendar-item-add-list.html',[],function () { return '{{#title}}\n<div class="separator">\n    <h3><span class="{{icon}}"></span> {{#t}}{{title}}{{/t}} <span class="total"><span\n        data-bind="html:collectionTotal"></span></span></h3>\n</div>\n{{/title}}\n\n<ul class="calendar-items"></ul>\n';});

